<template>
  <div id="app">
    <vx-router-view></vx-router-view>

    <div class="app1" v-if="showImg">
      <img class="img" @click="prewImg" :src="url" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    console.log(process.env);
    let url = "";
    if (process.env.VUE_APP_x3_env == "prod") {
      url =
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/linshi-0001.png";
    } else {
      url =
        "https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/linshi-0002.png";
    }
    return {
      showImg: app.base.env == "wxxcx",
      url: url,
    };
  },
  methods: {
    prewImg() {
      vant.ImagePreview({
        images: [this.url],
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
// 全局 根路由/页面 基础样式
#app {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.app1 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 9;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .img {
    width: 75%;
  }
}
</style>
